import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-municipios',
  templateUrl: './municipios.component.html',
  styleUrls: ['./municipios.component.scss']
})
export class MunicipiosComponent implements OnInit {
  data;
  respuestaMunicipios:any;
  respuestaEstados:any;
  respuestaAgregarMunicipio:any;
  municipios;
  estados;
  formulario;
  estadoid;

  constructor(private _getEstados: CatalogosService, private _getMunicipios: CatalogosService, 
    private _agregarMunicipio:CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getEstados();

    this.formulario = {
      'nombre':'',
    }
  }

  getMunicipios(estado){
    this.data = {
      'estado':estado,
    }

    this.estadoid = estado;
    this._getMunicipios.getMunicipios(this.data).subscribe(
      data => {
        this.respuestaMunicipios = data;
        if(this.respuestaMunicipios.success){
          this.municipios = this.respuestaMunicipios.content;
        }
    }, error => console.error(error));
  }

  getEstados(){
    this._getEstados.getEstados().subscribe(
      data => {
        this.respuestaEstados = data;
        if(this.respuestaEstados.success){
          this.estados = this.respuestaEstados.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
      
  }


  agregarMunicipio(estado){
    this.data = {
      'nombre':this.formulario.nombre,
      'estado':estado,
    } 
   
    this._agregarMunicipio.agregarMunicipio(this.data).subscribe(
      response => { 
        this.respuestaAgregarMunicipio = response;
        if(this.respuestaAgregarMunicipio.success == 1){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = ''
          this.getMunicipios(this.estadoid);

          //cerrar el modal
          this.dismissAll();            
          }
      },
      error => console.log('error: ', error)
    )
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
